/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from './defs.defs.js'

const $nsid = 'app.bsky.feed.getListFeed'

export { $nsid }

/** Get a feed of recent posts from a list (posts and reposts from any actors on the list). Does not require auth. */
const main = l.query(
  $nsid,
  l.params({
    list: l.string({ format: 'at-uri' }),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    feed: l.array(
      l.ref<FeedDefs.FeedViewPost>((() => FeedDefs.feedViewPost) as any),
    ),
  }),
  ['UnknownList'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
